import SearchStore, { nullOrString } from 'src/search/store/SearchStore';
import getLocationTitle from 'src/search/utils/getLocationTitle';
import { DATE_FORMAT } from 'src/common/constants';
import { RecentSearch } from '../types/common/RecentSearch';
import { formatDate } from './dateHelpers';

const convertStoreToRecentSearch = (
  search: SearchStore,
): RecentSearch => ({
  location: search.location.value ? getLocationTitle(search.breadcrumbs) : null,
  place_id: search.placeId.value || null,
  dates: search.dates.value[0] ? search.dates.value.map((d) => formatDate(d, DATE_FORMAT)) : [],
  capacity: nullOrString(search.capacity.value),
  min_price: nullOrString(search.min_price.value),
  max_price: nullOrString(search.max_price.value),
  instabooks: search.instabooks.value,
  captained: search.captained.value,
  bareboat: search.bareboat.value,
  superowners: search.superowners.value,
  categories: search.categories.value,
  duration: search.duration.value,
});

export default convertStoreToRecentSearch;
